import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, EMPTY, map, merge, startWith, Subject, switchMap, takeUntil, of as observableOf } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
@Component({
  selector: 'app-whatsapp-template',
  templateUrl: './whatsapp-template.component.html',
  styleUrls: ['./whatsapp-template.component.scss']
})
export class WhatsappTemplateComponent {
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  totalRows = 0;
  currentPage = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  btnLoading = false;
  templateIDtoDelete: any;
  template: any;
  currentTime!: string;
  timerId: any;
  processedData: SafeHtml = '';
  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];
  countQuickReplyButton = 0;
  countCTAButtonForURL = 0;
  templateToEdit: any;
  initialLoad = true;
  templateToDelete: any;
  renderedData: any;
  header: any;
  footer: any;
  templateType: any;
  mediaId: any;
  isRefresh = false;
  carouselCards: any[] = [];
  previewCarouselIndex: number = 0;
  allTemplates: any[] = [];
  visibleTemplates: any[] = [];
  viewMode: 'cards' | 'table' = 'cards';
  categoryFilter = 'ALL';
  statusFilter = 'ALL';
  formatFilter = 'ALL';
  searchText = '';
  categoryFilters = [
    { id: 'ALL', label: 'All Categories' },
    { id: 'UTILITY', label: 'Utility' },
    { id: 'MARKETING', label: 'Marketing' },
  ];
  showAllVariables = false;
  selectedTemplateForRejection: any;
  appId: string = '184ca697-c88c-426f-8b06-b802c7ceaff3';
  appName: string = '';

  displayedColumns: string[] = [
    "Template",
    "Status",
    "action"
  ];

  private destroy$ = new Subject<void>();

  isAdmin: boolean = false; // Initialize isAdmin to false

  constructor(
    private toast: ToastrService,
    private api: WhatsappTemplateService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private sanitizer: DomSanitizer,
    private tracker: TrackingService

  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );

  }

  ngOnInit() {
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
    this.fetchAppConfig();
  }

  fetchAppConfig(): void {
    const payload = {
      client_id: this.localStorage.getClientId()
    };
    this.api.getAppId(payload).subscribe({
      next: (res: any) => {
        if (res?.app_id) this.appId = res.app_id;
        if (res?.app_name) this.appName = res.app_name;
      },
      error: (err: any) => {
        console.warn('Could not fetch whatsapp config', err);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }



  ngAfterViewInit() {
    this.loadData();
  }


  loadData(): void {
    try {
      const sortChange = this.sort?.sortChange ?? EMPTY;
      if (this.sort) {
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      }

      // Merge various observables to listen to changes in search, date filters, sort, and pagination
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        sortChange,
        this.paginator.page
      )
        .pipe(
          startWith({}), // Initialize stream on component load
          switchMap(() => {
            this.isRefresh = true; // Show progress bar or loader

            const params: any = {
              "where": {
                client_id: this.localStorage.getClientId(),
              },
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              "order": {
                "col": "\"template\".\"createdAt\"",
                "dir": "DESC"
              }
            }

            if (!this.isAdmin) {
              params.where.user_id = this.localStorage.getUserId();
            }

            // Call API to fetch templates, handle errors gracefully
            return this.api.getAllTemplate(params).pipe(
              catchError(() => {
                console.error('Error fetching templates');
                return observableOf([]); // Return empty array on error
              })
            );
          }),
          map((response: any) => {
            if (!response || !response.rows) {
              this.totalRows = 0;
              return [];
            }
            this.totalRows = response.count; // Set total row count for pagination
            return this.mapRows(response.rows);
          }),
          takeUntil(this.destroy$) // Clean up subscription on component destroy
        )
        .subscribe({
          next: (data) => {
            this.initialLoad = false;
            this.btnLoading = false;
            this.isRefresh = false;

            // Assign data to the dataSource for the MatTable
            this.dataSource = new MatTableDataSource<any>(data);
            this.refreshVisible();

            // Dismiss any open modals (if applicable)
            this.modalService.dismissAll();
          },
          error: (e) => {
            this.btnLoading = false;
            this.initialLoad = false;
            this.isRefresh = false;
            console.error('Subscription error:', e);
          },
        });
    } catch (e) {
      console.error('Unexpected error:', e);
    }
  }


  refreshStatus() {
    const body: any = {
      "client_id": this.localStorage.getClientId(),
    }

    if (!this.isAdmin) {
      body['user_id'] = this.localStorage.getUserId();
    }

    this.isRefresh = true;
    this.api.refreshGupshupTemplates(body).subscribe({
      next: () => {
        const desc = `Template status refreshed`;
        this.toast.success('Template updated successfully');
        this.tracker.track("Refresh", "WhatsappTemplate", desc); // ✅
        this.loadData();
        //this.handleUpdateData('refresh');
      },
      error: () => {
        this.isRefresh = false;
        this.toast.error("Error occurred while refreshing template status");
      }
    });
  }


  handleUpdateData(type?: string) {

    if (type === 'refresh') {
      this.isRefresh = true;
    }

    try {
      const params: any = {
        "where": {
          client_id: this.localStorage.getClientId(),
        },
        "page": this.paginator.pageIndex,
        "limit": this.paginator.pageSize,
        "order": {
          "col": "\"template\".\"updatedAt\"",
          "dir": "DESC"
        }
      }

      if (!this.isAdmin) {
        params.where.user_id = this.localStorage.getUserId();
      }

      this.api.getAllTemplate(params).subscribe({
        next: (response: any) => {
          if (response) {
            this.totalRows = response.count;
            const mapped = this.mapRows(response.rows);
            this.dataSource = new MatTableDataSource<any>(mapped);
            this.refreshVisible();

            if (type === 'update') {
              this.modalService.dismissAll();
              this.toast.success('Template updated successfully');
              const desc = `Template updated: ${mapped?.[0]?.elementName || 'Unnamed'}`;
              this.tracker.track("Edit", "WhatsappTemplate", desc); // ✅
            }

            if (type === 'create') {
              this.modalService.dismissAll();
              this.toast.success('Template created successfully');

              const desc = `Template created: ${mapped?.[0]?.elementName || 'Unnamed'}`;
              this.tracker.track("Create", "WhatsappTemplate", desc); // ✅
            }

            if (type === 'delete') {
              this.modalService.dismissAll();
              this.toast.success('Template deleted successfully');
              const desc = `Template deleted: ${this.templateToDelete?.elementName || 'Unnamed'}`;
              this.tracker.track("Delete", "WhatsappTemplate", desc); // ✅
            }

            if (this.isRefresh) {
              this.isRefresh = false;
            }

            this.btnLoading = false;

          } else {
            this.toast.warning('No templates found.');
          }
        },
        error: (error: any) => {
          console.error('Error fetching templates:', error);
          this.toast.error('Failed to update templates. Please try again later.');
        },
        complete: () => {
          console.log('Template fetching completed.');
        }
      });
    } catch (e) {
      console.error('Unexpected error:', e);
      this.toast.error('An unexpected error occurred.');
    }
  }


  closeModal() {
    this.modalService.dismissAll();
  }


  open(content: any) {
    this.modalService
      .open(content, { size: 'xl', scrollable: true, centered: true, backdrop: 'static', keyboard: false, windowClass: 'wa-template-modal-xl' });
  }

  handleDeleteEvent() {

    this.btnLoading = true;
    const payload = {
      client_id: this.localStorage.getClientId(),
      elementName: this.templateToDelete.elementName,
      template_id: this.templateToDelete.id
    }

    try {
       this.api.deleteTemplate(payload).subscribe(
      (response: any) => {
        if (response) {
          this.handleUpdateData('delete');
           this.btnLoading = false;
        }
      },
      (error: any) => {
        console.log(error)
        this.btnLoading = false;
        this.toast.error("Error occurred while deleting template");
      }
    );
    }
    catch(e){
        this.btnLoading = false;
        this.toast.error("Error occurred while deleting template");
    }

    setTimeout(()=>{
          this.btnLoading = false;
    },1500)
   

  }

  handleOpenDeleteTemplateDialog(content: any, element: any) {
    this.modalService
      .open(content, { size: 'md', centered: true,backdrop: 'static',  keyboard: false  })

    this.templateToDelete = element;
  }

  handleOpenPreviewDialog(content: any, template: any) {
    this.templateType = template.templateType || template.templatetype;
    this.carouselCards = [];
    this.previewCarouselIndex = 0;

    if (template.app_id) this.appId = template.app_id;
    if (template.app_name) this.appName = template.app_name;

    if (this.templateType === 'CAROUSEL' || this.templateType === 'carousel') {
      try {
        if (template.cards && Array.isArray(template.cards)) {
          this.carouselCards = template.cards;
        } else if (template.meta) {
          const parsed = typeof template.meta === 'string' ? JSON.parse(template.meta) : template.meta;
          if (parsed.cards && Array.isArray(parsed.cards)) {
            this.carouselCards = parsed.cards;
          }
        } else if (template.containerMeta) {
          const parsed = typeof template.containerMeta === 'string' ? JSON.parse(template.containerMeta) : template.containerMeta;
          if (parsed.cards && Array.isArray(parsed.cards)) {
            this.carouselCards = parsed.cards;
          }
        }
      } catch (e) {
        console.error('Error parsing carousel cards', e);
      }
    }

    if (template.templateType === 'IMAGE' || template.templateType === 'VIDEO' || template.templateType === 'DOCUMENT' || template.templateType === 'GIF') {
      const data = JSON.parse(template.meta);
      this.mediaId = data.mediaId;
    }
    const { header, body, footer } = this.splitString(template.containerMeta);
    this.header = header;
    this.footer = footer;
    const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(template.containerMeta);

    this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));

    this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url }));

    this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

    this.countQuickReplyButton = this.quickReplyButtons.length;

    this.countCTAButtonForURL = this.urlButtons.length;

    this.renderedData = this.formateData(body);

    this.modalService.open(content, {
      windowClass: 'wa-phone-preview-modal',
      centered: true,
    });
  }

  private mapRows(rows: any[]): any[] {
    this.allTemplates = rows || [];
    return (rows || []).map((row: any) => {
      const data = row?.template_data || row;
      data.created_at = row?.createdAt || data.created_at;
      data.updated_at = row?.updatedAt || data.updated_at;
      const userId = row?.user_id ?? row?.created_by ?? data.user_id;
      const userName = row?.user_name || row?.created_by_name || row?.user?.name || row?.User?.name;
      data.ownerLabel = userName || (userId != null && userId !== '' ? `User #${userId}` : '');
      return data;
    });
  }

  refreshVisible(): void {
    const query = (this.searchText || '').trim().toLowerCase();
    const rows = this.dataSource?.data || [];
    this.visibleTemplates = rows.filter((template: any) => {
      const category = (template?.category || '').toUpperCase();
      const status = (template?.status || '').toUpperCase();
      const format = (template?.templateType || template?.templatetype || '').toUpperCase();

      if (this.categoryFilter !== 'ALL' && category !== this.categoryFilter) {
        return false;
      }
      if (this.statusFilter !== 'ALL' && status !== this.statusFilter) return false;
      if (this.formatFilter !== 'ALL' && format !== this.formatFilter) return false;
      if (!query) return true;

      const haystack = `${template?.elementName || ''} ${template?.id || ''} ${template?.data || ''}`.toLowerCase();
      return haystack.includes(query);
    });
  }

  setCategory(category: string): void {
    this.categoryFilter = category;
    this.refreshVisible();
  }

  setViewMode(mode: 'cards' | 'table'): void {
    this.viewMode = mode;
  }

  statusTone(status: string): string {
    const value = (status || '').toUpperCase();
    if (value === 'APPROVED') return 'approved';
    if (value === 'PENDING') return 'pending';
    if (value === 'FAILED' || value === 'REJECTED') return 'failed';
    return 'neutral';
  }

  statusLabel(status: string): string {
    const value = (status || '').toUpperCase();
    if (value === 'APPROVED') return 'Approved';
    if (value === 'PENDING') return 'Pending';
    if (value === 'FAILED') return 'Failed';
    if (value === 'REJECTED') return 'Rejected';
    return status || 'Unknown';
  }

  languageLabel(code: string): string {
    if (!code) return '';
    return code.split('_')[0].toUpperCase();
  }

  categoryTone(category: string): string {
    const value = (category || '').toUpperCase();
    if (value === 'MARKETING') return 'marketing';
    if (value === 'UTILITY') return 'utility';
    return 'neutral';
  }

  get templateStats() {
    const rows = this.dataSource?.data || [];
    const categoryCount = (name: string) =>
      rows.filter((row: any) => (row?.category || '').toUpperCase() === name).length;
    return {
      total: this.totalRows || rows.length,
      utility: categoryCount('UTILITY'),
      marketing: categoryCount('MARKETING'),
      approved: rows.filter((row: any) => (row?.status || '').toUpperCase() === 'APPROVED').length,
      pending: rows.filter((row: any) => (row?.status || '').toUpperCase() === 'PENDING').length,
      action: rows.filter((row: any) => ['FAILED', 'REJECTED'].includes((row?.status || '').toUpperCase())).length,
      pageCount: rows.length,
    };
  }

  scrollCarouselPreview(direction: 'prev' | 'next'): void {
    if (direction === 'prev' && this.previewCarouselIndex > 0) {
      this.previewCarouselIndex--;
    } else if (direction === 'next' && this.previewCarouselIndex < this.carouselCards.length - 1) {
      this.previewCarouselIndex++;
    }
    const cardWidth = 212;
    const el = document.getElementById('tablePreviewCarouselTrack');
    if (el) {
      el.scrollTo({ left: this.previewCarouselIndex * cardWidth, behavior: 'smooth' });
    }
  }

  onCarouselTrackScroll(event: Event): void {
    const target = event.target as HTMLElement;
    if (target) {
      const cardWidth = 216;
      this.previewCarouselIndex = Math.round(target.scrollLeft / cardWidth);
    }
  }

  getCardImageUrl(card: any): string {
    if (!card) return 'assets/img/Gallary.png';
    if (card.mediaData && typeof card.mediaData === 'string' && card.mediaData.trim().length > 0) {
      return card.mediaData;
    }
    if (card.mediaUrl && typeof card.mediaUrl === 'string' && card.mediaUrl.trim().length > 0) {
      if ((card.mediaUrl.includes('/wamedia/app/') || card.mediaUrl.includes('/wamedia//')) && card.mediaId) {
        const appId = this.appId || '184ca697-c88c-426f-8b06-b802c7ceaff3';
        return `https://api.gupshup.io/wa/${appId}/wa/media/${card.mediaId}?download=false`;
      }
      return card.mediaUrl;
    }
    if (card.mediaId) {
      const appId = this.appId || '184ca697-c88c-426f-8b06-b802c7ceaff3';
      return `https://api.gupshup.io/wa/${appId}/wa/media/${card.mediaId}?download=false`;
    }
    return 'assets/img/Gallary.png';
  }

  onCardImageError(event: any, card: any): void {
    const target = event?.target as HTMLImageElement;
    if (!target) return;
    if (card?.mediaId && !target.src.includes('/wa/media/' + card.mediaId)) {
      const appId = this.appId || '184ca697-c88c-426f-8b06-b802c7ceaff3';
      target.src = `https://api.gupshup.io/wa/${appId}/wa/media/${card.mediaId}?download=false`;
      return;
    }
    if (!target.src.includes('Gallary.png')) {
      target.src = 'assets/img/Gallary.png';
      target.style.objectFit = 'contain';
      target.style.padding = '20px';
    }
  }

  handleOpenRejectedReasonDialog(content: any, template: any) {
    this.selectedTemplateForRejection = template;
    this.modalService.open(content, { centered: true, size: 'md' });
  }

  formateData(data: any) {
    return data
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  splitString(inputString: any) {

    // Parse the input string as JSON
    const inputData = JSON.parse(inputString);

    // Extract the header, body (data), and footer from the JSON object
    const { header, data: body, sampleText, footer } = inputData;

    return {
      header: header,
      body: this.updateSampleText(sampleText),
      footer: footer
    };
  }

  updateSampleText(input: string): string {
    return input.replace(/\[(.*?)\]/g, '$1');
  }


  formatMessage(message: string): string {
    if (!message) return '';
    message = message.split('|')[0].trim();
    return message
      .replace(/\n/g, '<br>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }
  formatMessage2(message: string): string {
    if (!message) return '';
    message = message.split('|')[0].trim();
    return message
      .replace(/\n/g, '') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {
    const quickReplyButtons: string[] = [];
    const urlButtons: { text: string, urlType: string, url: string }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL
          urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }

  handleOpenEditDialog(content: any, template: any) {
 
   const foundTemplate = this.allTemplates.find(
      tpl => tpl.meta_template_id === template.id
    );

     console.log('foundTemplate:', foundTemplate);

      if (!foundTemplate) {
        console.error('Template not found for id:', template.id);
        return;
      }

      // IMPORTANT: clone object to avoid reference issues
      this.templateToEdit = { ...foundTemplate };

      this.modalService.open(content, {
        size: 'xl',
        scrollable: true,
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'wa-template-modal-xl'
      });

  }

}
